import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { NotionSpeedTester } from "./NotionSpeedTester";
import "./index.css";

export function App() {
  return (
    <div className="w-full mx-auto p-8 text-center relative z-10">
      <Card className="w-full max-w-4xl min-w-[320px] md:min-w-4xl mx-auto">
        <CardHeader className="gap-4">
          <CardTitle className="text-3xl font-bold">
            Notion Faster 配置
          </CardTitle>
        </CardHeader>
        <CardContent>
          <NotionSpeedTester />
        </CardContent>
      </Card>
      <footer className="mt-8 text-sm text-muted-foreground">
        Powered by{" "}
        <a
          href="https://notionfaster.org"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary hover:underline"
        >
          notionfaster.org
        </a>
      </footer>
    </div>
  );
}
